import { logSearch4, log, setSearch4BizTagType } from './logger';
import { baseLogger } from './baseLogger';

export {
    baseLogger,
    log,
    logSearch4,
    setSearch4BizTagType,
}
